import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-not-found-component",
	templateUrl: "./not-found-component.html",
	standalone: false,
})
export class NotFoundComponent {
	constructor() {}
}
